module.exports = __webpack_public_path__ + "static/media/ua.6d944bf7.svg";